import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, inject, Inject, input, OnInit, output, PLATFORM_ID, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ConnectedPosition } from '@angular/cdk/overlay';
import moment from 'moment';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'clever-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    standalone: false
})
export class DateComponent implements OnInit {
    mode = input<string>('');
    start = input<string>('');
    customwidth = input<string>('');
    end = input<string>('');
    mindauer = input<number>(-1);
    maxdauer = input<number>(-1);
    selectValue = output<any>();

    isBrowser = signal<boolean>(false);
    showModal = signal<boolean>(false);
    focus = signal<boolean>(false);

    local_start = signal<string>('');
    local_end = signal<string>('');
    local_dauername = signal<string>('');
    local_mindauer = signal<number>(-1);
    local_maxdauer = signal<number>(-1);

    searchObj: Observable<any>;
    mySearchControl = new FormControl();
    selectedList: any[] = [];

    destroyRef = inject(DestroyRef);
    selecteddif = signal<number>(null);

    overlaypos: ConnectedPosition[] = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        }
    ];

    constructor(
        protected mediaService: MediaService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        this.local_end.set(this.end());
        this.local_start.set(this.start());
        this.local_mindauer.set(this.mindauer());
        this.local_maxdauer.set(this.maxdauer());
        this.local_dauername.set(this.getDauertitle());
        if (this.local_start() && this.local_end) {
            this.selecteddif.set(moment(this.local_end()).diff(moment(this.local_start()), 'days'));
        }
    }

    getDauertitle(): string {
        let title = '';
        if (this.local_mindauer() === -1) {
            title = 'Genaue Reisedaten';
        } else if (this.local_mindauer() === this.local_maxdauer()) {
            title = this.local_mindauer() + (this.local_mindauer() === 1 ? ' Tag' : ' Tage');
        } else {
            title = this.local_mindauer() + '-' + this.local_maxdauer() + ' Tage';
        }



        return title;
    }

    openModal() {
        this.showModal.set(true);
        this.focus.set(true);
    }

    openModalMobile(ev) {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.showModal.set(true);
        this.focus.set(true);
    }

    closeModal() {
        this.showModal.set(false);
        this.mySearchControl.setValue('');
    }

    closeModalMobile() {
        this.showModal.set(false);
        // this.render.removeClass(document.body, 'model-open');
        this.mySearchControl.setValue('');
    }

    sendRes(res) {
        this.local_end.set(res.end);
        this.local_start.set(res.start);
        this.local_mindauer.set(res.minDuration);
        this.local_maxdauer.set(res.maxDuration);
        this.local_dauername.set(res.dauer_name);
        this.selectValue.emit(res);
        this.closeModal();
    }
}
